import React from 'react';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

// SVG
import { FormattedMessage } from 'react-intl';
import {
  ScenicSvg,
  SeasideSvg,
  StraightSvg,
  TwistedSvg,
  MountainSvg,
} from '../MainMenu/svg';

// import mountain from '../../../../static/img/preview/mountain.png';
// import scenic from '../../../../static/img/preview/scenic.png';
// import seaside from '../../../../static/img/preview/seaside.png';
// import straight from '../../../../static/img/preview/straight.png';
// import twisted from '../../../../static/img/preview/twisted.png';

import { detectArrowTourType } from '../../Utility/utility';

export const TourTypesFilter = ({ type, updateType, tourIcon }) => {
  const { isScenic, isMountain, isSeaside, isTwisted, isStraight } =
    detectArrowTourType(type);

  const getNewType = (num, isSelected) =>
    isSelected ? +type - num : +type + num;

  const changeHandler = (e, val) =>
    updateType(getNewType(+e.target.value, val));

  const { width, height } = tourIcon;

  return (
    <div className="tourTypeFilterLayout">
      <div>
        <Checkbox
          checked={isSeaside}
          onChange={(e) => changeHandler(e, isSeaside)}
          value="4"
        >
          <SeasideSvg width={width} height={height} />
          <span className="tour-type-text">
            <FormattedMessage id="Seaside" defaultMessage="Seaside" />
          </span>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={isMountain}
          onChange={(e) => changeHandler(e, isMountain)}
          value="2"
        >
          <MountainSvg width={width} height={height} />
          <span className="tour-type-text">
            <FormattedMessage id="Mountain" defaultMessage="Mountain" />
          </span>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={isScenic}
          onChange={(e) => changeHandler(e, isScenic)}
          value="1"
        >
          <ScenicSvg width={width} height={height} />
          <span className="tour-type-text">
            <FormattedMessage id="Scenic" defaultMessage="Scenic" />
          </span>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={isStraight}
          onChange={(e) => changeHandler(e, isStraight)}
          value="16"
        >
          <TwistedSvg width={width} height={height} />
          <span className="tour-type-text">
            <FormattedMessage id="Twisted" defaultMessage="Twisted" />
          </span>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={isTwisted}
          onChange={(e) => changeHandler(e, isTwisted)}
          value="8"
        >
          <StraightSvg width={width} height={height} />
          <span className="tour-type-text">
            <FormattedMessage id="Straight" defaultMessage="Straight" />
          </span>
        </Checkbox>
      </div>
    </div>
  );
};

TourTypesFilter.propTypes = {
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateType: PropTypes.func,
  tourIcon: PropTypes.object,
};
